export default __webpack_public_path__ + "static/media/3.b1c7d293.png";